(function ( $ ) {
	$.fn.sticky = function(options) {

		var defaults = {
			container		: 'body',
			header			: null,//'header',
			header_height	: null,
			bottom_buffer	: 0,
			side			: 'left',
			updateOnClick	: null, //'.simple_filter h5, .next-page'
			debug			: false
		};

		var settings = $.extend( defaults, options );
		var block = this; // jquery selectorius, kuriam iskvietem .sticky()

		var last_scroll_top = 0;
		var last_direction = 'up';

		var init = function() {

			$(document).on('touchmove', function() {
				fix();
			});

			$(window).scroll(function() {
				fix();
			});
			$(window).resize(function() {
				fix();
			});

			$(settings.updateOnClick).on('click', function(e){
				e.preventDefault();
				fix(true);
			});

			fix();
		}

		var fix = function(clicked) {

			var device_pass = true;
			if (settings.device == 'desktop' && $(window).width() < 992) device_pass = false;
			if (settings.device == 'mobile' && $(window).width() >= 992) device_pass = false;
			if (!device_pass) {
				block.css({ position:'static', top:'auto', bottom:'auto' });
				return;
			}

			var bottom_buffer = settings.bottom_buffer;

			var block_height = block.height();
			var block_top = block.offset().top;

			var container = $(settings.container);
			var container_height = container.height();
			var container_top = container.offset().top;

			var window_height = $(window).height();
			var document_top = $(document).scrollTop();

			var header_height = $(settings.header).height();
			if (settings.header_height) {
				header_height = settings.header_height;
			}
			if (header_height == null) header_height = 0;

			var direction = 'up';
			if (last_scroll_top < document_top) {
				direction = 'down';
			}

			function fix_side() {
				if (settings.side == 'right') {
					if (block.css('position') == 'fixed') {
						block.css('right', parseInt($(window).width()) - parseInt(container.position().left + container.width()) );
					} else {
						block.css('right', 0);
					}
				} else {
					//block.css('left', block.position().left);
					block.css('left', 'auto');
				}
			}

			// position 'fixed' neturi plocio, tai nustatom pagal parent'a
			block.outerWidth(block.parent().width());

			var situation = 0;
			// jeigu blokas didesnis uz conteineri, darom blocka static
			if (block_height >= container_height /* || $(window).width() <= 992 */) {
				block.css('position', 'static');
				situation = -1;
			} else {

				//console.log(block_height + block_top , container_height + container_top);
				// jeigu menu apacia virsyja containerio dugna
				if (block_height + block_top > container_height + container_top) {
					//block.css('position', 'absolute').css('bottom', 'auto').animate({ 'top': container_height - block_height }, 500);
					block.css('position', 'absolute').css('bottom', 'auto').css('top', container_height - block_height);
					fix_side();
					situation = 10;
				} else {

					// jeigu menu telpa i langa
					//if (window_height - container_top > block_height) {
					if (window_height > block_height) {

						if ((direction == 'down' && block.css('position') != 'fixed') && (document_top + header_height > container_top) && (block_top <= container_top)) {
							block.css('position', 'fixed').css('top', header_height);
							fix_side();
							situation = 7;
						}
						if (direction == 'up' && document_top + header_height < container_top) {
							block.css('position', 'absolute').css('top', 'auto');
							fix_side();
							situation = 8;
						}
						if (direction == 'down' && block_top + block_height + bottom_buffer > container_top + container_height) {
							block.css('position', 'absolute').css('bottom', 'auto').css('top', container_height - block_height - bottom_buffer);
							fix_side();
							situation = 9;
						}

					} else {

						// Jeigu scrollinam zemyn ir pasiekiam bloko dugna, fiksuojam bloka prie apacios
						if (direction == 'down' && document_top + window_height > block_top + block_height + bottom_buffer) {
							block.css('position', 'fixed').css('bottom', bottom_buffer).css('top', 'auto');
							fix_side();
							situation = 1;
						}

						// Jeigu scrollinam zemyn ir pasiekiam containerio dugna, fiksuojam bloka prie containerio dugno
						if (direction == 'down' && document_top + window_height > container_top + container_height) {
							block.css('position', 'absolute').css('bottom', 'auto').css('top', container_height - block_height - bottom_buffer);
							fix_side();
							situation = 2;
						}
					}

					// Jeigu scrollinam virsun ir pasiekiam bloko virsu
					if (direction == 'up' && block_top > document_top + header_height) {
						block.css('position', 'fixed').css('bottom', 'auto').css('top', header_height);
						fix_side();
						situation = 3;
					}

					// jeigu scrollinam i virsu ir blokas pasieke conteinerio virsu
					if (direction == 'up' && container_top >= document_top + header_height) {
						block.css('position', 'absolute').css('bottom', 'auto').css('top', 'auto');
						fix_side();
						situation = 4;
					}

					// jeigu scrollinam virsun, blokas fiksuotas prie apacios
					if (direction == 'up' && block.css('position') == 'fixed' && block_top < document_top + header_height) {
						block.css('position', 'absolute').css('bottom', 'auto').css('top', block_top - container_top);
						fix_side();
						situation = 5;
					}

					if (direction == 'down' && document_top + window_height < block_top + block_height + bottom_buffer) {
						block.css('position', 'absolute').css('bottom', 'auto').css('top', block_top - container_top);
						fix_side();
						situation = 6;
					}
				}

				if (clicked) {
					// jeigu pvz po click'o blockas telpa, bet yra uz ribu
					if (document_top + header_height > block_top && block.css('position') == 'absolute' && window_height - header_height - bottom_buffer > block_height) {
						block.css('position', 'fixed').css('top', header_height);
						fix_side();
					}
				}
			}

			if (settings.debug) {
				console.log({
					situation: situation,
					block_height: block_height,
					block_top: block_top,
					container_height: container_height,
					container_top: container_top,
					window_height: window_height,
					document_top: document_top,
					header_height: header_height,
					direction: direction,
					last_scroll_top: last_scroll_top
				});
			}

			last_scroll_top = document_top;
			last_direction = direction;

		}

		return this.each(function() {
			init();
		});
	};
}( jQuery ));
